import React from 'react';
import { FormattedMessage } from 'react-intl';

import { ugcContentAdvisoryShape } from '@bibliocommons/bc-prop-types';

import { ExpandableText } from 'app/components/shared/Expandable';
import DisplayWrapper from '../DisplayWrapper';

import './ContentAdvisoryDisplay.scss';

export default class ContentAdvisoryDisplay extends React.PureComponent {
  render() {
    return (
      <DisplayWrapper className="cp-ugc-content-advisory-display">
        <FormattedMessage id={`${this.props.notice.get('type')}_advisory_type`} tagName="strong" />
        :
        <ExpandableText text={this.props.notice.get('notice')} />
      </DisplayWrapper>
    );
  }
}

ContentAdvisoryDisplay.propTypes = {
  notice: ugcContentAdvisoryShape.isRequired
};
